import { Box } from '@mui/material';
import React from 'react';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import ScrollToTop from '../ScrollToTop/ScrollToTop';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        flexDirection: 'column'
      }}
    >
      <div className="no-print" style={{ width: '100%' }}>
        <Navbar />
      </div>
      <Box sx={{ flexGrow: 1, width: '100%', display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
      <footer className="no-print" style={{ width: '100%', marginTop: 'auto' }}>
        <Footer />
      </footer>
      <ScrollToTop />
    </Box>
  );
};

export default Layout;
